import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Container, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { PageLoadingSpinner } from "../../../components/Common/CommonButton";
import { breadcrumbReturnFunc } from "../../../components/Common/CommonFunction";
import { mode, pageId } from "../../../routes";
import { commonPageField, commonPageFieldSuccess } from "../../../store/actions";
import useDashboardData from "./hooks/useDashboardData";
import KPISection from "./components/sections/KPISection";
import PosOverviewSection from "./components/sections/PosOverviewSection";
import PurchaseSection from "./components/sections/PurchaseSection";
import ERPSection from "./components/sections/ERPSection";
import ItemSaleSection from "./components/sections/ItemSaleSection";
import ProductionSection from "./components/sections/ProductionSection";
import StockStatusSection from "./components/sections/StockStatusSection";
import TopSellingCompaniesSection from "./components/sections/TopSellingCompaniesSection";
import UserAnalyticsSection from "./components/sections/UserAnalyticsSection";
import ModuleUsageSection from "./components/sections/ModuleUsageSection";
import SecuritySection from "./components/sections/SecuritySection";
import SystemHealthSection from "./components/sections/SystemHealthSection";
import RecentActivitySection from "./components/sections/RecentActivitySection";
import "./SuperAdminDashboard.scss";

const SuperAdminDashboard = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { data, loading, sectionLoading } = useDashboardData();
  const location = { ...history.location };
  const hasShowModal = props.hasOwnProperty(mode.editValue);
  const { userAccess } = useSelector((state) => ({
    userAccess: state.Login.RoleAccessUpdateData,
    pageField: state.CommonPageFieldReducer.pageField,
  }));

  const handleNavigate = useCallback(
    (path) => {
      history.push(path);
    },
    [history]
  );

  useEffect(() => {
    dispatch(commonPageFieldSuccess(null));
    dispatch(commonPageField(pageId.SUPER_ADMIN_DASHBOARD));
  }, [dispatch]);

  useEffect(() => {
    let locationPath = location.pathname;
    if (hasShowModal) locationPath = props.masterPath;
    const userAcc = userAccess.find((inx) => `/${inx.ActualPagePath}` === locationPath);
    if (userAcc) breadcrumbReturnFunc({ dispatch, userAcc });
  }, [userAccess, dispatch, hasShowModal, location.pathname, props.masterPath]);

  return (
    <React.Fragment>
      <PageLoadingSpinner isLoading={loading} />
      <div className="page-content super-admin-dashboard">
        <Container fluid>
          <KPISection data={data} loading={sectionLoading} onNavigate={handleNavigate} />

          <PosOverviewSection loading={sectionLoading} />

          <Row className="super-admin-row-stretch">
            <PurchaseSection loading={sectionLoading} />
            <ERPSection loading={sectionLoading} />
          </Row>

          <Row className="super-admin-row-stretch">
            <ItemSaleSection loading={sectionLoading} />
            <ProductionSection loading={sectionLoading} />
          </Row>

          <Row className="super-admin-row-stretch">
            <StockStatusSection loading={sectionLoading} />
            <TopSellingCompaniesSection loading={sectionLoading} />
          </Row>

          <Row className="super-admin-row-stretch">
            <UserAnalyticsSection loading={sectionLoading} />
            <ModuleUsageSection loading={sectionLoading} />
          </Row>

          <Row className="super-admin-row-stretch">
            <SecuritySection loading={sectionLoading} />
            <SystemHealthSection loading={sectionLoading} />
          </Row>

          <RecentActivitySection logs={data.logs} loading={sectionLoading} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminDashboard;
